import { w as withConfigTransport } from "../../../../services/config-transport/withConfigTransport-2705a6a5.mjs";
import { _ as _VaTimePickerColumn } from "./VaTimePickerColumn-2bf78376.mjs";
const VaTimePickerColumn = withConfigTransport(_VaTimePickerColumn);
export {
  VaTimePickerColumn as V
};
//# sourceMappingURL=index-83a2cb3f.mjs.map
